import { IModule, IQService, IRootScopeService, noop } from "angular";
import { AnalyticsService } from "@gtmhub/core/analytics";
import { eventToPromise } from "@gtmhub/util";
import { IAccount } from "@gtmhub/core";

export function trackPageLoadTime(mod: IModule) {
  let ngBootstrapTiming: number;
  mod.config(() => {
    ngBootstrapTiming = performance.now();
  });

  mod.run([
    "$rootScope",
    "$q",
    "AnalyticsService",
    ($rootScope: IRootScopeService, $q: IQService, analyticsService: AnalyticsService) => {
      const observePerformanceEntry = (name: string, type: string) =>
        $q<number>((resolve, reject) => {
          if ("PerformanceObserver" in window) {
            const observer = new PerformanceObserver((entries: PerformanceObserverEntryList) => {
              for (const entry of entries.getEntriesByName(name, type)) {
                observer.disconnect();
                resolve(entry.startTime);
                break;
              }
            });
            observer.observe({ type, buffered: true });
          } else {
            reject();
          }
        });

      $q.all({
        firstContentfulPaint: observePerformanceEntry("first-contentful-paint", "paint"),
        firstNgNavigation: observePerformanceEntry("Root State Enter", "mark"),
        // wait for the account to be initialized, so that we have accountId available
        account: eventToPromise<IAccount>($q, $rootScope, "accountDataInitialized"),
      }).then((results) => {
        const appBundleTiming = (<PerformanceResourceTiming[]>performance.getEntriesByType("resource")).find((x) => x.name.match(/\/main(\.\w+)?\.js$/i));

        const performanceMeasurements = {
          first_contentful_paint: results.firstContentfulPaint,
          app_bundle_fetched: appBundleTiming ? appBundleTiming.responseEnd : undefined,
          ng_bootstrap: ngBootstrapTiming,
          first_ng_navigation: results.firstNgNavigation,
          account_id: results.account.id,
        };

        const event = "Webapp Loaded";

        // eslint-disable-next-line no-console
        console.info(event, performanceMeasurements);

        analyticsService.track(event, performanceMeasurements);
      }, noop);
    },
  ]);
}
